<app-main-navbar [wipperozLogo]="wipperozLogo" [navbarClass]="'navbar-color-white'"></app-main-navbar>
<div class="wipperoz-main-banner" [ngStyle]="{ 'background-image': 'url(' + bannerBGImage + ')' }">
  <div class="container">
    <div class="wipperoz-main-content">
      <h1 i18n="@@hirePeopleTitle" style="color: var(--whiteColor)">
        <span style="color: var(--pinkColor)">Get things done</span>! Hire the most talented people to work
        <span style="color: var(--pinkColor)">online</span> or <span style="color: var(--pinkColor)">onsite</span>
      </h1>
      <h2 i18n="@@hirePeopleSubTitle" style="color: var(--whiteColor)">Connect with the best around the world</h2>
      <div class="others-option">
        <a [href]="urlSignUp" target="_blank" class="btn btn-primary" i18n="@@hireSomeoneButton">Hire now</a
        ><a [href]="urlSignUp" target="_blank" class="mx-4 btn btn-light" i18n="@@getHiredButton">Get hired & earn</a>
      </div>
    </div>
  </div>
  <app-wip-steps></app-wip-steps>
</div>
<app-wipperoz-services></app-wipperoz-services>
<app-ngo></app-ngo>
<app-pricing></app-pricing>
<app-feedback></app-feedback>
<app-join-today></app-join-today>
<app-recent-blog-articles></app-recent-blog-articles>
<div class="footer">
  <app-footer [showGoogle]="false"></app-footer>
</div>
